(() => {
  const form = document.getElementById('YofProjectEnquiry');
  const selection = form?.querySelector('[name="contact[product_selection]"]');
  const snapshot = form?.querySelector('[name="contact[cart_snapshot]"]');
  const warning = form?.querySelector('[data-quote-cart-error]');
  const button = form?.querySelector('[type="submit"]');
  if (!selection || !warning || !button || form.dataset.cartSyncBound) return;
  form.dataset.cartSyncBound = 'true';
  let submitting = false;
  let forward = false;
  let revision = 0;
  const query = window.location?.search ? new URLSearchParams(window.location.search) : null;
  const directProduct = query?.get('quote_product');
  const directRequested = query?.has('quote_product') || query?.has('quote_variant') || query?.has('quote_quantity');
  const directLine = async signal => {
    if (!directRequested) return null;
    const id = query.get('quote_variant');
    const quantity = Number(query.get('quote_quantity'));
    if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(directProduct || '') || !/^\d+$/.test(id || '') || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error('Invalid configuration request');
    const response = await fetch(`${window.Shopify.routes.root}products/${directProduct}.js`, {cache:'no-store', signal, credentials:'same-origin'});
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    const variant = product.variants?.find(variant => String(variant.id) === id);
    if (!variant || !product.title) throw new Error('Configuration not found');
    return `${product.title} | ${variant.title || 'Default Title'} | SKU: ${variant.sku || ''} | Variant ID: ${id} | Quantity: ${quantity}`;
  };
  const changing = () => Boolean(document.querySelector('.cart__items--disabled'));
  const fail = () => {
    warning.textContent = warning.dataset.message;
    warning.hidden = false;
  };
  const refresh = async () => {
    const current = ++revision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        cache: 'no-store', signal: controller.signal, credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Basket unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid basket');
      const lines = cart.items.map(item => {
        if (!Number.isSafeInteger(item.variant_id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) {
          throw new Error('Invalid basket item');
        }
        const properties = Object.entries(item.properties || {}).filter(([name, value]) => !name.startsWith('_') && value !== '' && value !== null);
        const extras = properties.length ? ` | Options: ${JSON.stringify(Object.fromEntries(properties))}` : '';
        return `${item.product_title} | ${item.variant_title || 'Default Title'} | SKU: ${item.sku || ''} | Variant ID: ${item.variant_id} | Quantity: ${item.quantity}${extras}`;
      });
      if (current !== revision) throw new Error('Basket changed');
      const requested = await directLine(controller.signal);
      if (current !== revision) throw new Error('Basket changed');
      if (requested) lines.unshift(`${warning.dataset.directLabel}\n${requested}`);
      selection.value = lines.length ? `${lines.join('\n')}\n` : warning.dataset.empty;
      if (snapshot) snapshot.value = JSON.stringify({
        version: 1,
        currency: cart.currency || 'AUD',
        product_total_minor: cart.total_price ?? null,
        items: cart.items.map(item => ({variant_id: item.variant_id, quantity: item.quantity, sku: item.sku || '', title: item.product_title, variant: item.variant_title || 'Default Title', properties: Object.fromEntries(Object.entries(item.properties || {}).filter(([name]) => !name.startsWith('_')))})),
        separate_configuration: requested || null
      });
      warning.hidden = true;
    } finally {
      clearTimeout(timeout);
    }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (!submitting) refresh().catch(fail);
    });
  }
  if (directRequested) refresh().catch(fail);
  form.addEventListener('submit', async event => {
    if (forward) { forward = false; return; }
    event.preventDefault();
    if (submitting) return;
    if (changing()) { fail(); return; }
    submitting = true;
    button.disabled = true;
    try {
      await refresh();
      if (changing()) throw new Error('Basket updating');
      button.disabled = false;
      forward = true;
      form.requestSubmit(button);
      forward = false;
    } catch (_) {
      fail();
    } finally {
      button.disabled = false;
      submitting = false;
    }
  });
})();
